module.exports = __webpack_public_path__ + "img.png?5e0543d08e82afc58d16a1dfef55400b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/attachment-format/img.png
// module id = 49
// module chunks = 0